import type { ErrorResponse } from '@/types/apiTypes';

const ATTACHMENT_ERROR_FIELD = 'attachment_media_uuids';

/**
 * Whether sf-api rejected the Send Forms attachments: the service reports `attachment_media_uuids`,
 * the request rules report one key per file (`attachment_media_uuids.0`).
 */
export const hasShareAttachmentError = (errorResponse: ErrorResponse<unknown> | undefined): boolean =>
  Object.keys(errorResponse?.errors ?? {}).some(
    (field) => field === ATTACHMENT_ERROR_FIELD || field.startsWith(`${ATTACHMENT_ERROR_FIELD}.`)
  );
